export const BiographyBookSampleData = [
    {
        id: 1,
        author: "K",
        title: "K의 일기 : K 자서전",
        publisher: "하남시 나룰도서관",
        year: 2020,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["event (5)", "사람 (23)", "학교 (620)", "지역(3)"],
        img: "redbook1.png"
    },
    {
        id: 2,
        author: "Nam-sig Gross",
        title: "남식 : 한국의 피, 독일의 국적… 두 문화 사이 한 여성의 삶",
        publisher: "행복에너지",
        year: 2017,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["문화 (15)", "해외 (8)", "이민 (3)", "가족 (12)"]
    },
    {
        id: 3,
        author: "가산약학역사관",
        title: "(한국 약학의 아버지) 녹암 한구동",
        publisher: "서울대학교 약학대학",
        year: 2016,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["의학 (25)", "교육 (42)", "연구 (18)", "역사 (31)"]
    },
    {
        id: 4,
        author: "감사용",
        title: "슈퍼스타 감사용 : 꿈과 도전, 그리고 인생이야기",
        publisher: "대경북스",
        year: 2008,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["연예 (7)", "도전 (15)", "꿈 (28)", "인생 (45)"],
        img: "redbook2.png"
    },
    {
        id: 5,
        author: "강경구",
        title: "成功은 마음먹기에 달렸다 시련은 있어도 불가능은 없다 : 남강 강경구 자서전",
        publisher: "국가상훈편찬위원회",
        year: 1992,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["성공 (33)", "도전 (15)", "극복 (22)", "동기부여 (8)"]
    },
    {
        id: 6,
        author: "강경우 외",
        title: "평범한 듯 특별한 : 2016. 목포공공도서관「자서전 써 드리기」작품집",
        publisher: "목포공공도서관",
        year: 2016,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["지역 (10)", "일상 (25)", "이야기 (30)", "공동체 (15)"]
    },
    {
        id: 7,
        author: "강관희",
        title: "꿈이 있어 좌절은 없다 : 교육의원 강관희 자서전",
        publisher: "강관희",
        year: 2013,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["교육 (42)", "정치 (18)", "도전 (15)", "리더십 (20)"]
    },
    {
        id: 8,
        author: "강금순",
        title: "살아온 아흔두 해, 걸음마다 은총이었네 : 강금순요안나 자서전",
        publisher: "시산맥사",
        year: 2021,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["신앙 (12)", "노년 (8)", "가족 (12)", "회고 (35)"]
    },
    {
        id: 9,
        author: "강기동",
        title: "강기동과 한국 반도체 : 강기동 자서전",
        publisher: "아모르문디",
        year: 2018,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["산업 (28)", "기술 (45)", "혁신 (15)", "경제 (20)"]
    },
    {
        id: 10,
        author: "강기천",
        title: "(姜起千 回顧錄)나의 人生 旅路",
        publisher: "계몽사",
        year: 1996,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["인생 (45)", "여정 (12)", "회고 (35)", "역사 (31)"]
    },
    {
        id: 11,
        author: "강기필",
        title: "山을 넘고 江을 건너면서 : 새로운 곳을 향해 달려온 도전의 연속",
        publisher: "BookLab(북랩)",
        year: 2016,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["도전 (15)", "여정 (12)", "성장 (25)", "극복 (22)"]
    },
    {
        id: 12,
        author: "강길순",
        title: "남한테는 백 점 나한테는 빵점",
        publisher: "해성",
        year: 2020,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["성찰 (18)", "교육 (42)", "자아 (15)", "성장 (25)"]
    },
    {
        id: 13,
        author: "강노섭",
        title: "초원은 잡초가 지킨다",
        publisher: "Design studio think rive(디자인스튜디오 씽크라이브);광주광역시 서구 어르신 자서전 제작사업",
        year: 2017,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["지역 (10)", "노년 (8)", "자연 (15)", "지혜 (20)"]
    },
    {
        id: 14,
        author: "강달수",
        title: "나의 인생 기록",
        publisher: "서영",
        year: 2015,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["인생 (45)", "회고 (35)", "기록 (8)", "성찰 (18)"]
    },
    {
        id: 15,
        author: "강대연",
        title: "감사로 풀어내는 인연의 실타래",
        publisher: "동구 노인문화센터;미소",
        year: 2019,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["관계 (25)", "감사 (12)", "인연 (18)", "노년 (8)"]
    },
    {
        id: 16,
        author: "강대원",
        title: "형사25시 : 30년 수사관의 수사애환과 인생역정",
        publisher: "해치",
        year: 2009,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["수사 (8)", "경찰 (12)", "직업 (30)", "정의 (15)"]
    },
    {
        id: 17,
        author: "강대찬",
        title: "땀으로 가꾼 나무는 쓰러지지 않는다 : 姜大贊 自敍傳",
        publisher: "태극",
        year: 2005,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["노력 (28)", "성공 (33)", "인생 (45)", "도전 (15)"]
    },
    {
        id: 18,
        author: "강덕기",
        title: "서울시와 함께한 나의 길 : 강덕기 수상록",
        publisher: "기파랑",
        year: 2017,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["행정 (15)", "공직 (20)", "서울 (8)", "봉사 (12)"]
    },
    {
        id: 19,
        author: "강동인",
        title: "아름다운 인생 행복한 사람",
        publisher: "희망사업단",
        year: 2014,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["행복 (35)", "인생 (45)", "긍정 (18)", "성찰 (18)"]
    },
    {
        id: 20,
        author: "강두순",
        title: "진실이 묻어나는 아름다운 약속 : 생애 최고의 순간들",
        publisher: "책과나무",
        year: 2015,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["인생 (45)", "순간 (15)", "약속 (8)", "진실 (12)"]
    },
    {
        id: 21,
        author: "강영식",
        title: "영식씨의 인생여행",
        publisher: "월간조선",
        year: 2020,
        library: "국립중앙도서관",
        content: "회고록 중 단락 내용이 노출됩니다...",
        tags: ["여행 (20)", "인생 (45)", "모험 (15)", "회고 (35)"]
    }
]